import { render, staticRenderFns } from "./LandingCerfa.vue?vue&type=template&id=18224b31&scoped=true"
import script from "./LandingCerfa.vue?vue&type=script&lang=js"
export * from "./LandingCerfa.vue?vue&type=script&lang=js"
import style0 from "./LandingCerfa.vue?vue&type=style&index=0&id=18224b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18224b31",
  null
  
)

export default component.exports